import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";

import { useStyles } from "../../../../Components/CSS/FormStyle.css";
import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import StudentFormFilter from "./StudentFormFilter/StudentFormFilter";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import CustomTableHead from "../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import VehicleStudentBody from "./VehicleStudentBody/VehicleStudentBody";
import CustomTableFooter from "../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import FormLoader from "../../../../Components/FormLoader/FormLoader";
import CustomEmptyMessage from "../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class ManageVehicleStudent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 20,
      page: 0,
      vehicleList: [],
      studentList: [],
      students: [],
      vehicleId: "",
      column: [
        { name: "S.N." },
        { name: "Full Name" },
        { name: "Address" },
        { name: "Class" },
      ],
      searchBy: {
        session: new Date().getFullYear(),
        class: "",
        faculty: "",
        group: "",
        section: "",
      },
      isEmpty: false,
      studentInVehicleError: false,
      loading: false,
    };
  }

  componentDidMount() {
    this.getVehicles();
  }

  getVehicles = async () => {
    try {
      const response = await Axios.get(`${url}/api/vehicles`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.vehicles.length !== 0) {
        this.setState({ vehicleList: response.data.vehicles });
      } else {
        this.setState({ vehicleList: [] });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getVehicles();
      }
    }
  };

  getStudents = async () => {
    try {
      const response = await Axios.get(`${url}/api/students`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.students.length !== 0) {
        this.setState({
          studentList: response.data.students,
          isEmtpy: false,
        });
      } else {
        this.setState({
          studentList: [],
          isEmtpy: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getStudents();
      }
    }
  };

  handleChange = (e) => {
    this.setState({
      vehicleId: e.target.value,
    });
  };

  handleSearchChange = (e) => {
    this.setState({
      searchBy: {
        ...this.state.searchBy,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleChangeClass = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        class: e.target.value,
        faculty: "",
        group: "",
        section: "",
      },
    });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  handleSelectAllClick = (e) => {
    if (e.target.checked) {
      const newSelected = this.state.studentList.map((data) => data._id);
      this.setState({
        students: newSelected,
      });
      return;
    }
    this.setState({
      students: [],
    });
  };

  handleClick = (students) => {
    this.setState({
      students,
    });
  };

  checkError = () => {
    let studentInVehicleError = "";
    if (this.state.students.length === 0) {
      studentInVehicleError = "At least enter one student in vehicle";
    }

    if (studentInVehicleError) {
      this.setState({ studentInVehicleError });
      return true;
    } else {
      this.setState({ studentInVehicleError: "" });
      return false;
    }
  };

  handleVehicleStudent = async () => {
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        this.setState({ loading: true });
        const response = await Axios.put(
          `${url}/api/vehicles/${this.state.vehicleId}/add-student`,
          { students: this.state.students },
          {
            headers: { Authorization: `Bearer ${this.props.adminToken}` },
          }
        );
        if (response.data.message === "Students added successfully") {
          this.props.history.push(
            `/administration/vehicle/details/${this.state.vehicleId}`
          );
        }
      } catch (error) {
        this.setState({ loading: false });
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handleVehicleStudent();
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { rowsPerPage, page, searchBy } = this.state;
    const filtered = this.state.studentList.filter((student) => {
      return (
        student.currentSession
          .toString()
          .indexOf(searchBy.session.toString()) !== -1 &&
        student.studentClass.indexOf(searchBy.class) !== -1
      );
    });
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />
          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle title="Manage Student in Vehicle" />
          <TextField
            name="vehicleId"
            label="Vehicle of Route"
            select
            required
            variant="outlined"
            margin="normal"
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            className={classes.inputWithMargin}
            value={this.state.vehicleId}
            onChange={this.handleChange}
          >
            <option value="">Select any vehicle route</option>
            {this.state.vehicleList.map((vehicle, index) => (
              <option key={index} value={vehicle._id}>
                Vehicle-{index + 1} {vehicle.route}
              </option>
            ))}
          </TextField>
          <br />

          <Button
            type="submit"
            variant="outlined"
            onClick={this.getStudents}
            className={classes.buttonStyle}
          >
            Get Students
          </Button>

          {this.state.studentList.length !== 0 && (
            <>
              <StudentFormFilter
                handleChangeClass={this.handleChangeClass}
                data={this.state.searchBy}
                handleChange={this.handleSearchChange}
              />
              <div style={{ display: "flex", alignItems: "center" }}>
                <Button
                  variant="outlined"
                  className={classes.buttonStyle}
                  onClick={this.handleVehicleStudent}
                >
                  Add To Vehicles
                </Button>
                {this.state.loading && <FormLoader />}
                {this.state.studentInVehicleError && (
                  <div style={{ color: "red" }}>
                    {this.state.studentInVehicleError}
                  </div>
                )}
              </div>
            </>
          )}

          {this.state.studentList.length !== 0 ? (
            <TableContainer>
              <Table>
                <CustomTableHead
                  column={this.state.column}
                  showCheckbox={true}
                  numSelected={this.state.students.length}
                  onSelectAllClick={this.handleSelectAllClick}
                  rowCount={this.state.studentList.length}
                />

                <TableBody>
                  {(rowsPerPage > 0
                    ? filtered.slice(
                        rowsPerPage * page,
                        rowsPerPage * page + rowsPerPage
                      )
                    : filtered
                  ).map((student, index) => (
                    <VehicleStudentBody
                      key={index}
                      index={index}
                      data={student}
                      handleClick={this.handleClick}
                      students={this.state.students}
                    />
                  ))}
                </TableBody>

                <CustomTableFooter
                  count={filtered.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={this.handlePage}
                  onChangeRowsPerPage={this.handleRowsPerPage}
                />
              </Table>
            </TableContainer>
          ) : this.state.isEmpty ? (
            <CustomEmptyMessage description="Studnet List is empty" />
          ) : (
            <CustomEmptyMessage description="Please fill above form" />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ManageVehicleStudent)));
